import { Component, Input, Output, EventEmitter } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';

@Component({
  selector: 'feature-notification',
  templateUrl: './feature-notification.component.html',
  styleUrls: ['./feature-notification.component.scss'],
  animations: fuseAnimations,
})
export class FeatureNotificationComponent {
  @Input() feature: {
    title?: string;
    description?: string;
    buttonLabel?: string;
    showNotification?: boolean;
    requiresReconnection?: boolean;
    showUntil?: string;
    roomsToReconnect?: any[];
    // ...otros campos si los necesitas
  };
  @Input() type: 'info' | 'success' | 'warning' | 'error' = 'info';

  @Output() action = new EventEmitter<void>();

  visible: boolean = true;

  onActionClick() {
    this.action.emit();
  }

  onClose() {
    this.visible = false;
  }
}
